function showModel(sel) { 
  $('.model').empty();        
  $('.model').html('<option value="">Model</option>');
  var make_value = sel.options[sel.selectedIndex].value;	  
  if (make_value.length > 0 ) {      
    $.getJSON('/collections/'+make_value+'/products.json', function(response) {      
      var clickId = [];      
      $.each(response.products, function(index,itemdata){
        var mdtag = itemdata.tags;        
        $.each(mdtag,function(i,ptag){
          if(ptag.indexOf('model') != -1){                 
            if(clickId.indexOf(ptag) == -1){
              clickId.push(ptag)
            }
          }
        });
        $('.model').empty();
        $('.model').html('<option value="">Model</option>');
        $.each(clickId,function(i,clicktag){
          $('.model').append('<option value="'+clicktag+'" data-handle="'+make_value+'">'+clicktag.replace('model-','')+'</option>'); 
        });          
      });

    });
  } 
}
$( document ).ready(function() {
  
  $('#makeoutput select').val("");
  $('#show_year').change(function(e){
    var model_value = $(this).val();
    var coll_handle = $(this).find(':selected').attr('data-handle');

    if (model_value.length > 0 ) {      
      $.getJSON('/collections/'+coll_handle+'/products.json', function(response) {    

        var clickId = [];   
        var tag_items = [];
        $.each(response.products, function(index,itemdata){
          var mdtag = itemdata.tags;        
          var tag_year = false;
          $.each(mdtag,function(i,ptag){
            if(ptag == model_value){                 
              tag_year = true;
            }
          });
          $.each(mdtag,function(i,ptag){
            if(ptag.indexOf('year') != -1 && tag_year == true && clickId.indexOf(ptag) == -1){
              clickId.push(ptag)
            }
          });
          $('.year').empty();
          $('.year').html('<option value="">Year</option>');
          $.each(clickId,function(i,clicktag){
           // console.log(jQuery.inArray(clicktag,itemdata.tags));
           // console.log(itemdata.handle); 
            if(jQuery.inArray(clicktag,itemdata.tags) !== -1){
              // console.log(itemdata.handle); 
              tag_items.push({'itemhandle':itemdata.handle,'clicktag':clicktag}); 
              //tag_items[i]['clicktag'] = clicktag; 
            //	$('.year').append('<option value="'+clicktag+'" data-handle="'+itemdata.handle+'">'+clicktag.replace('year-','')+'</option>'); 
            }
           
          });
        });
        
        $.each(tag_items,function(i,tag_item){
          $('.year').append('<option value="'+tag_item.clicktag+'" data-handle="'+tag_item.itemhandle+'">'+tag_item.clicktag.replace('year-','')+'</option>'); 
        });
        
         
      });
      
    } 

  });

  $('#show_product').change(function(e){
    var pro_handle = $(this).find(':selected').attr('data-handle');
    $('.productoutput').val(pro_handle);
     $('#search_btn').removeAttr("disabled");
    $("#search_btn").addClass("hoverclass");
  });


  $('#search_btn').click(function(e){
    e.preventDefault();
    var product_handle = $(this).prev().val();    
    if (product_handle != '') {  
      var clickId = [];
      $.getJSON('/products/'+product_handle+'.js', function(response) {           
        if(response.images[0]){
          var prdimage = response.images[0];
        }else{
          var prdimage = 	"//www.aascomotorsports.com/cdn/shop/t/16/assets/no-image_300x.gif?v=34404572178591518461791930689";
        }  
        var yrtag = response.tags;        
        $.each(yrtag,function(i,ytag){
          if(ytag.indexOf('year') != -1){                 
            if(clickId.indexOf(ytag) == -1){
              clickId.push(ytag);
            }
          }
        });
        var product_details = '';
        var thenum = response.price;
        var price = (thenum-(thenum%100))/100;        
        product_details = '<div class="product-layout product-grid grid-style col-md-4 col-sm-6 col-xs-6 three-items"><div class="product-thumb"><div class="item item2"><div class="item-inner"><div class="col-image"><div class="image images-container">';
        product_details = product_details+'<a href="'+response.url+'" class="product-image"><img src="'+prdimage+'" width="500" alt="" /></a>';
        product_details = product_details+'<div class="col-des"><div class="caption">';
        product_details = product_details+'<h4 class="product-name"><a href="'+response.url+'">'+response.title+'</a></h4>';
        product_details = product_details+'<p class="product-detail"><span>Engine: </span>'+response.type+'</p>';
        product_details = product_details+'<p class="product-detail"><span>Year: </span>'+clickId[0].replace('year-','')+'</p>';
        product_details = product_details+'<div class="price-box"><p class="regular-price"><span class="price">$'+price+'.00</span></p></div>';
        product_details = product_details+'<div class="product-des">'+response.description+'</div>';
        product_details = product_details+'<button class="button btn-cart" type="button" data-toggle="tooltip" data-loading-text="Loading..." title="" onclick="cart.add('+response.variants[0].id+');" data-original-title="Add to Cart">';
        product_details = product_details+'<span>Add to Cart</span>';
        product_details = product_details+'</button>';
        product_details = product_details+'</div></div>';
        product_details = product_details+'</div></div></div></div></div></div>';
        $(".custom-category").css("display", "none");
        $("#productshow").html(product_details);
      });
    } 
  });
});